import { render, staticRenderFns } from "./TasksDetailMobile.vue?vue&type=template&id=0334c434"
import script from "./TasksDetailMobile.vue?vue&type=script&lang=js"
export * from "./TasksDetailMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports